// src/Components/NavBar.jsx
import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom"; // Removed useNavigate
import styles from "./NavBar.module.css";

const NavBar = () => {
  // Removed unused isLoggedIn and setIsLoggedIn
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const hoverTimeoutRef = useRef(null);
  const location = useLocation();
  // Removed unused navigate

  useEffect(() => {
    // Handle scroll effect
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown when route changes
  useEffect(() => {
    setActiveDropdown(null);
    closeMobileMenu();
  }, [location]);

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    document.body.style.overflow = !isMobileMenuOpen ? "hidden" : "auto";
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    document.body.style.overflow = "auto";
  };

  const isActiveLink = (path) => {
    return location.pathname === path;
  };

  // Handle dropdown hover with delay
  const handleDropdownHover = (dropdownName) => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    setActiveDropdown(dropdownName);
  };

  const handleDropdownLeave = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setActiveDropdown(null);
    }, 300);
  };

  // Handle dropdown menu mouse enter/leave
  const handleDropdownMenuEnter = () => {
    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
  };

  const handleDropdownMenuLeave = () => {
    setActiveDropdown(null);
  };

  // WhatsApp handler
  const handleWhatsApp = () => {
    window.open("https://wa.me/917847820335?text=Hi%2C%20I%20have%20a%20query%20about%20Exademy%20courses", "_blank");
  };

  // Download App handler
  const handleDownloadApp = () => {
    window.open("https://play.google.com/store/apps/details?id=co.rogers.cufxp&pcampaignid=web_share", "_blank");
  };

  // Course dropdown data structure - REMOVED UPSC Statistics Optional and BPSC STET Paper II
  const courseCategories = [
    {
      title: "UPSC Mathematics Optional - 2026",
      path: "/#upsc-section"  // Anchor link to UPSC section
    },
    {
      title: "UPSC Mathematics Optional - 2027",
      path: "/upsc-math-twentySeven"  // This remains a full page
    },
    {
      title: "BPSC Mathematics Optional",
      path: "/#bpsc-section"  // Anchor link to BPSC section
    },
    {
      title: "BPSC STET 2026 Mathematics",
      path: "/#stet-section"  // Anchor link to STET section
    },
    // REMOVED: BPSC STET 2026 Mathematics Paper-II
    {
      title: "UPSC 2026 CSAT",
      path: "/#csat-section"  // Anchor link to CSAT section
    },
    {
      title: "CSIR NET Mathematics",
      path: "/#csir-section"
    }
    // REMOVED: UPSC Statistics Optional - 2027
  ];

  // PYQ dropdown data structure
  const pyqCategories = [
    {
      title: "UPSC Mathematics Optional",
      path: "/upsc-pyq"
    },
    {
      title: "BPSC Mathematics Optional",
      path: "/bpsc-pyq"
    },
    {
      title: "CSAT",
      path: "/csat-pyq"
    }
  ];

  // Services dropdown data structure
  const serviceCategories = [
    {
      title: "Advanced Scientific Study Skills & Memory Techniques",
      path: "/services/study-skills-memory-techniques"
    },
    {
      title: "1:1 Mentorship Programme",
      path: "/mentorship-page"
    },
    {
      title: "STUD Talks",
      path: "/stud-talks"
    },
    {
      title: "Personality Development Batch (Physical & Cognitive)",
      path: "/courses/personality-development-batch"
    }
  ];

  return (
    <>
      <header className={`${styles.navbar} ${isScrolled ? styles.scrolled : ""}`}>
        <div className={styles.navContainer}>
          {/* Logo Section */}
          <div className={styles.logoSection}>
            <Link to="/" className={styles.logoLink} onClick={closeMobileMenu}>
              <div className={styles.logoWrapper}>
                <img src="/logo/logo.png" alt="Exademy" className={styles.logoImage} />
                <span className={styles.companyName}>Exademy</span>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className={styles.navLinks} ref={dropdownRef}>
            <Link 
              to="/" 
              className={`${styles.navLink} ${isActiveLink("/") ? styles.active : ""}`}
            >
              Home
            </Link>
            
            {/* Courses Dropdown */}
            <div 
              className={styles.dropdownContainer}
              onMouseEnter={() => handleDropdownHover('courses')}
              onMouseLeave={handleDropdownLeave}
            >
              <button 
                className={`${styles.dropdownToggle} ${isActiveLink("/courses") ? styles.active : ""}`}
                onMouseEnter={() => handleDropdownHover('courses')}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveDropdown(activeDropdown === 'courses' ? null : 'courses');
                }}
              >
                Courses
                <span className={styles.dropdownArrow}>▼</span>
              </button>
              
              {activeDropdown === 'courses' && (
                <div 
                  className={styles.dropdownMenu}
                  onMouseEnter={handleDropdownMenuEnter}
                  onMouseLeave={handleDropdownMenuLeave}
                >
                  <div className={styles.dropdownGrid}>
                    {courseCategories.map((category, index) => (
                      <div key={index} className={styles.dropdownItemWrapper}>
                        <Link 
                          to={category.path} 
                          className={styles.dropdownItemLink}
                          onClick={closeMobileMenu}
                        >
                          <span className={styles.dropdownItemTitle}>{category.title}</span>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Services Dropdown */}
            <div 
              className={styles.dropdownContainer}
              onMouseEnter={() => handleDropdownHover('services')}
              onMouseLeave={handleDropdownLeave}
            >
              <button 
                className={`${styles.dropdownToggle} ${isActiveLink("/services") ? styles.active : ""}`}
                onMouseEnter={() => handleDropdownHover('services')}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveDropdown(activeDropdown === 'services' ? null : 'services');
                }}
              >
                Services
                <span className={styles.dropdownArrow}>▼</span>
              </button>
              
              {activeDropdown === 'services' && (
                <div 
                  className={styles.dropdownMenu}
                  onMouseEnter={handleDropdownMenuEnter}
                  onMouseLeave={handleDropdownMenuLeave}
                >
                  <div className={styles.dropdownGrid}>
                    {serviceCategories.map((category, index) => (
                      <div key={index} className={styles.dropdownItemWrapper}>
                        <Link 
                          to={category.path} 
                          className={styles.dropdownItemLink}
                          onClick={closeMobileMenu}
                        >
                          <span className={styles.dropdownItemTitle}>{category.title}</span>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link 
              to="/ebook-store" 
              className={`${styles.navLink} ${isActiveLink("/ebook-store") ? styles.active : ""}`}
            >
              E-Book Store
            </Link>
            <Link 
              to="/exam-corner" 
              className={`${styles.navLink} ${isActiveLink("/exam-corner") ? styles.active : ""}`}
            >
              Exam Corner
            </Link>
            
            {/* PYQ's Dropdown */}
            <div 
              className={styles.dropdownContainer}
              onMouseEnter={() => handleDropdownHover('pyq')}
              onMouseLeave={handleDropdownLeave}
            >
              <button 
                className={`${styles.dropdownToggle} ${isActiveLink("/pyq") ? styles.active : ""}`}
                onMouseEnter={() => handleDropdownHover('pyq')}
                onClick={(e) => {
                  e.preventDefault();
                  setActiveDropdown(activeDropdown === 'pyq' ? null : 'pyq');
                }}
              >
                PYQ's
                <span className={styles.dropdownArrow}>▼</span>
              </button>
              
              {activeDropdown === 'pyq' && (
                <div 
                  className={styles.dropdownMenu}
                  onMouseEnter={handleDropdownMenuEnter}
                  onMouseLeave={handleDropdownMenuLeave}
                >
                  <div className={styles.dropdownGrid}>
                    {pyqCategories.map((category, index) => (
                      <div key={index} className={styles.dropdownItemWrapper}>
                        <Link 
                          to={category.path} 
                          className={styles.dropdownItemLink}
                          onClick={closeMobileMenu}
                        >
                          <span className={styles.dropdownItemTitle}>{category.title}</span>
                        </Link>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </nav>

          {/* Auth Section - WhatsApp + Download App Button */}
          <div className={styles.authSection}>
            {/* WhatsApp Button */}
            <button 
              className={styles.whatsappBtn}
              onClick={handleWhatsApp}
              aria-label="Chat on WhatsApp"
              title="Chat with us on WhatsApp"
            >
              <i className="fab fa-whatsapp"></i>
            </button>

            {/* Download App Button */}
            <button 
              className={styles.downloadAppBtn}
              onClick={handleDownloadApp}
            >
              <i className="fab fa-android"></i>
              Download our App
            </button>

            {/* Mobile Menu Toggle */}
            <button 
              className={`${styles.mobileMenuToggle} ${isMobileMenuOpen ? styles.open : ""}`}
              onClick={toggleMobileMenu}
              aria-label="Toggle navigation menu"
            >
              <span className={styles.hamburgerLine}></span>
              <span className={styles.hamburgerLine}></span>
              <span className={styles.hamburgerLine}></span>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Navigation Menu - Moved OUTSIDE the header */}
      <div className={`${styles.mobileMenu} ${isMobileMenuOpen ? styles.open : ""}`}>
        <div className={styles.mobileMenuHeader}>
          <div className={styles.mobileLogoWrapper}>
            <img src="/logo/logo.png" alt="Exademy" className={styles.mobileLogoImage} />
            <span className={styles.companyName}>Exademy</span>
          </div>
          <button 
            className={styles.closeMenuBtn}
            onClick={closeMobileMenu}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>
        <nav className={styles.mobileNavLinks}>
          <Link 
            to="/" 
            className={`${styles.mobileNavLink} ${isActiveLink("/") ? styles.active : ""}`}
            onClick={closeMobileMenu}
          >
            <span className={styles.mobileLinkIcon}>🏠</span>
            Home
          </Link>
          
          {/* Mobile Courses Dropdown */}
          <div className={styles.mobileDropdownContainer}>
            <div className={styles.mobileDropdownHeader}>
              <span className={styles.mobileLinkIcon}>📚</span>
              <span className={styles.mobileNavLinkText}>Courses</span>
            </div>
            <div className={styles.mobileDropdownContent}>
              {courseCategories.map((category, index) => (
                <div key={index} className={styles.mobileDropdownSection}>
                  <Link 
                    to={category.path} 
                    className={styles.mobileCategoryLink}
                    onClick={closeMobileMenu}
                  >
                    {category.title}
                  </Link>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile Services Dropdown */}
          <div className={styles.mobileDropdownContainer}>
            <div className={styles.mobileDropdownHeader}>
              <span className={styles.mobileLinkIcon}>⚙️</span>
              <span className={styles.mobileNavLinkText}>Services</span>
            </div>
            <div className={styles.mobileDropdownContent}>
              {serviceCategories.map((category, index) => (
                <div key={index} className={styles.mobileDropdownSection}>
                  <Link 
                    to={category.path} 
                    className={styles.mobileCategoryLink}
                    onClick={closeMobileMenu}
                  >
                    {category.title}
                  </Link>
                </div>
              ))}
            </div>
          </div>

          <Link 
            to="/ebook-store" 
            className={`${styles.mobileNavLink} ${isActiveLink("/ebook-store") ? styles.active : ""}`}
            onClick={closeMobileMenu}
          >
            <span className={styles.mobileLinkIcon}>📱</span>
            E-Book Store
          </Link>
          <Link 
            to="/exam-corner" 
            className={`${styles.mobileNavLink} ${isActiveLink("/exam-corner") ? styles.active : ""}`}
            onClick={closeMobileMenu}
          >
            <span className={styles.mobileLinkIcon}>📝</span>
            Exam Corner
          </Link>

          {/* Mobile PYQ's Dropdown */}
          <div className={styles.mobileDropdownContainer}>
            <div className={styles.mobileDropdownHeader}>
              <span className={styles.mobileLinkIcon}>📄</span>
              <span className={styles.mobileNavLinkText}>PYQ's</span>
            </div>
            <div className={styles.mobileDropdownContent}>
              {pyqCategories.map((category, index) => (
                <div key={index} className={styles.mobileDropdownSection}>
                  <Link 
                    to={category.path} 
                    className={styles.mobileCategoryLink}
                    onClick={closeMobileMenu}
                  >
                    {category.title}
                  </Link>
                </div>
              ))}
            </div>
          </div>

          {/* Mobile WhatsApp & Download App Buttons */}
          <div className={styles.mobileAuthSection}>
            <button 
              className={`${styles.mobileAuthBtn} ${styles.whatsappBtnMobile}`}
              onClick={() => {
                handleWhatsApp();
                closeMobileMenu();
              }}
            >
              <i className="fab fa-whatsapp"></i>
              Chat on WhatsApp
            </button>
            <button 
              className={`${styles.mobileAuthBtn} ${styles.downloadAppBtnMobile}`}
              onClick={() => {
                handleDownloadApp();
                closeMobileMenu();
              }}
            >
              <i className="fab fa-android"></i>
              Download our App
            </button>
          </div>
        </nav>
      </div>

      {/* Overlay for mobile menu */}
      {isMobileMenuOpen && (
        <div 
          className={styles.mobileMenuOverlay} 
          onClick={closeMobileMenu}
        ></div>
      )}
    </>
  );
};

export default NavBar;